<template>
  <VView class="contest-instructions" back-button-to="/menu" :header="$t('contestInstructions.header')">
    <VText>{{ $t('contestInstructions.content.0') }}</VText>
    <VText>{{ $t('contestInstructions.content.1') }}</VText>

    <VBlock max-width="300px">
      <transition name="bounceUp" appear>
        <VButton to="/contest/game">{{ $t('contestInstructions.cta') }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'ContestInstructions',
};
</script>

<style lang="scss" scoped>
.contest-instructions {}
</style>
